export const CreditHistoryColumns = [
  {
    title: "Action Name",
  },

  {
    title: "Transaction Type",
  },
  {
    title: "Credits",
  },
  {
    title: "Balance ",
  },
  {
    title: "Description",
  },
  {
    title: "Created At",
  },
];
